import React from "react";

import { IconButton, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import {
  StyledAutocompleteContainer,
  StyledAutocomplete,
  StyledChip,
  StyledPaper,
  PaperContainer,
} from "../TagsAutocomplete/ItemTagsAutocomplete.styles";

import { StyledIconButton, StyledSearchOutlinedIcon } from "./SearchTagAutocomplete.style";
import { splitKey, v4RenderOption } from "../../_utils/autocompleteCompat";

interface ItemTagsAutocompleteProps {
  searchValue: string;
  checkedTags: string[];
  allTags: string[];
  allTagsLoaded: boolean;
  placeholder: string;
  clearInput: () => void;
  setTags: (newValue: string[]) => void;
  onInputChange: (event: any, value: string) => void;
  limitTags?: number;
}

const SearchTagsAutocomplete: React.FC<ItemTagsAutocompleteProps> = ({
  onInputChange,
  checkedTags,
  allTags,
  allTagsLoaded,
  clearInput,
  setTags,
  searchValue,
  placeholder,
  limitTags = 2,
}) => {
  const renderEndInputIcon = (searchValue: string, tags: string[]): React.ReactNode => {
    return (
      <>
        {!searchValue && !tags.length ? (
          <StyledSearchOutlinedIcon />
        ) : (
          <StyledIconButton onClick={clearInput}>
            <ClearIcon />
          </StyledIconButton>
        )}
      </>
    );
  };

  return (
    <StyledAutocompleteContainer size={12}>
      <StyledAutocomplete
        id="tags"
        multiple
        limitTags={limitTags}
        value={checkedTags}
        options={allTags}
        filterSelectedOptions
        clearOnBlur={false}
        openOnFocus={true}
        onChange={(event, newValue) => {
          setTags(newValue);
        }}
        renderValue={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => {
            const [key, tagProps] = splitKey(getTagProps({ index }) as any);
            return (
              <StyledChip
                key={key}
                deleteIcon={
                  <IconButton size="small">
                    <ClearIcon />
                  </IconButton>
                }
                label={option}
                {...tagProps}
              />
            );
          });
        }}
        onInputChange={onInputChange}
        loading={allTagsLoaded}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              // inputRef={desktopInputElement}
              variant="outlined"
              placeholder={checkedTags.length === 0 ? placeholder : ""}
              slotProps={{
                ...params.slotProps,
                input: {
                  ...params.slotProps.input,
                  endAdornment: renderEndInputIcon(searchValue, checkedTags),
                },
              }}
            />
          );
        }}
        renderOption={v4RenderOption((option: any, state) => {
          return <StyledChip label={option} />;
        })}
        slots={{
          paper: ({ children }) => (
            <PaperContainer>
              <StyledPaper>{children}</StyledPaper>
            </PaperContainer>
          ),
        }}
      />
    </StyledAutocompleteContainer>
  );
};

export default SearchTagsAutocomplete;
